/*
 * @Author: Teemo Ding
 * @Date: 2021-11-25 16:11:17
 * @LastEditTime: 2022-03-04 15:01:09
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/Components/RefundCard/index.tsx
 */
import React, { Fragment } from 'react';

import css from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

interface IProps {
  transactions?;
  title: string;
  onViewDetails?: () => void;
  refundCardButton?;
  cardIntroduce?;
}

const RefundCard = ({
  transactions = [],
  title = '',
  onViewDetails,
  refundCardButton,
  cardIntroduce = [],
}: IProps) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <Fragment>
      <div className={css.refundCardTop}>
        <div
          className={
            !(transactions || []).length ? css.refundCardNoLine : css.refundCard
          }>
          <div className={css.refundCardDetail}>
            <h3>{title}</h3>

            {onViewDetails && (
              <span onClick={onViewDetails}>
                {getI18n('allOrders.orderDetail.refund_return_viewdetails')}
              </span>
            )}
          </div>

          <div className={css.refundCardButton}>{refundCardButton}</div>
        </div>

        <div className={css.refundContain}>
          {(cardIntroduce || []).map((item, index) => (
            <div key={index} className={css.refundItem}>
              <span>{item.name}</span>
              <span>{item.text}</span>
            </div>
          ))}
        </div>
      </div>
      {(transactions || []).map((item, index) => (
        <div key={index}>
          {item.header}
          <div className={css.refundHeader}>
            <span className={css.title}>{item.title}</span>
            {item.buttons}
          </div>

          <div className={css.refundContain}>
            {(item.introduce || []).map((item) => (
              <div className={css.refundItem}>
                <span>{item.name}</span>
                <span>{item.text}</span>
              </div>
            ))}
          </div>
        </div>
      ))}
    </Fragment>
  );
};

export default RefundCard;
